<script setup lang="ts">

// const route = useRoute()

</script>
<template>
  <div>
    <AppHeader />

    <UMain>
      <UContainer>
        <slot />
      </UContainer>
    </UMain>

    <NuxtLoadingIndicator />
  </div>
</template>

<style>

</style>
